export const createItem = (options: ItemOption, template: HTMLTemplateElement, parent: HTMLElement) => {
  const clone = template.content.cloneNode(true) as HTMLElement
  const title = options.title ?? options.value ?? ""
  const cloneTitle = clone.querySelector<HTMLTitleElement>(".i-tag__title")
  const cloneElement = cloneTitle?.closest<HTMLElement>(".i-selected-tag")
  const resetBtn = document?.querySelector<HTMLElement>(".js-filter-clear")

  if (cloneTitle) cloneTitle.innerHTML = `${options.prefix ?? ""} ${title} ${options.suffix ?? ""}`
  if (!options.id) return

  cloneElement?.setAttribute("data-filter-item-target", options.id)
  removeItem(options.id, parent)

  cloneElement?.addEventListener("click", () => {
    document.querySelectorAll<HTMLInputElement>(`#${options.id}, #${options.id} input`).forEach((input) => input.dispatchEvent(new Event("clear")))
  })

  if (cloneElement) parent?.insertBefore(cloneElement, resetBtn)
}

export const removeItem = (id: string, parent: HTMLElement) => {
  if (!id) return
  parent.querySelectorAll<HTMLElement>(`[data-filter-item-target=${id}]`).forEach((item) => item.remove())
}

export type ItemOption = {
  value: string
  title: string
  id: string
  prefix: string
  suffix: string
}
